import request from "src/api/request-manager/gateway";

import type { CheckPassword, CheckPhoneNumber, CompanyProfile, MTFacilConfig } from "./types/setting.types";

const settingPrefixURL = "/dashboard/v1/setting";

const customHead = { "content-type": "multipart/form-data" };

const SettingAPI = {
  // Company profile
  getCompanyProfile(): Promise<CompanyProfile> {
    return request.get<CompanyProfile>(`${settingPrefixURL}/company-profile`);
  },
  updateCompanyProfile(params: unknown) {
    return request.post(`${settingPrefixURL}/company-profile`, params, customHead);
  },

  // Notifications
  getDepositNotification() {
    return request.get(`${settingPrefixURL}/deposit-notification`);
  },
  updateDepositNotification(params: unknown) {
    return request.post(`${settingPrefixURL}/deposit-notification`, params);
  },
  getTransactionNotification() {
    return request.get(`${settingPrefixURL}/transaction-notification`);
  },
  updateTransactionNotification(params: unknown) {
    return request.post(`${settingPrefixURL}/transaction-notification`, params);
  },

  // Auto split
  getAutoSplitConfig() {
    return request.get(`${settingPrefixURL}/auto-split-transaction`);
  },
  updateAutoSplitConfig(params: unknown) {
    return request.post(`${settingPrefixURL}/auto-split-transaction`, params);
  },

  // Deposit auto withdrawal
  getDepositAutoWithdrawal() {
    return request.get(`${settingPrefixURL}/deposit-auto-withdrawal`);
  },
  updateDepositAutoWithdrawal(data: unknown) {
    return request.put(`${settingPrefixURL}/deposit-auto-withdrawal`, data);
  },

  // Deposit activation / company bank account
  activateDeposit(data: unknown) {
    return request.put(`${settingPrefixURL}/deposit-activation`, data);
  },
  updateCompanyBankAccount(data: unknown) {
    return request.put(`${settingPrefixURL}/update-company-bank-account`, data);
  },

  // MT Facil config
  getMTFacilConfig(): Promise<MTFacilConfig> {
    return request.get<MTFacilConfig>(`${settingPrefixURL}/bulk-pull-mt-facil`);
  },
  updateMTFacilConfig(data: unknown) {
    return request.post(`${settingPrefixURL}/bulk-pull-mt-facil`, data);
  },

  // Two Factor Auth
  getTwoFactorAuth() {
    return request.get(`${settingPrefixURL}/tfa-setup`);
  },
  twoFactorAuthSetup(data: unknown) {
    return request.post(`${settingPrefixURL}/tfa-setup`, data);
  },
  validateTwoFactorAuth(data: unknown) {
    return request.post(`${settingPrefixURL}/tfa`, data);
  },

  // Password
  checkPassword(data: unknown): Promise<CheckPassword> {
    return request.post<CheckPassword>(`${settingPrefixURL}/check-password`, data);
  },
  updatePassword(data: unknown): Promise<CheckPassword> {
    return request.post<CheckPassword>(`${settingPrefixURL}/update-password`, data);
  },

  // Email
  updateEmail(data: unknown) {
    return request.post(`${settingPrefixURL}/update-email`, data);
  },
  verifyEmail(data: unknown): Promise<CheckPassword> {
    return request.post<CheckPassword>(`${settingPrefixURL}/verify-email-update`, data);
  },

  // Phone update flow
  updatePhoneRequestAccess(data: unknown) {
    return request.post(`${settingPrefixURL}/update-phone-request-access`, data);
  },
  updatePhoneVerifyAccess(data: unknown) {
    return request.post(`${settingPrefixURL}/update-phone-verify-access`, data);
  },
  updatePhoneCheckNumber(data: unknown): Promise<CheckPhoneNumber> {
    return request.post<CheckPhoneNumber>(`${settingPrefixURL}/update-phone-check-number`, data);
  },
  updatePhoneRequestProcess(data: unknown) {
    return request.post(`${settingPrefixURL}/update-phone-request-process`, data);
  },
  updatePhoneVerifyProcess(data: unknown) {
    return request.post(`${settingPrefixURL}/update-phone-verify-process`, data);
  },

  // OTP
  sendOTP(data: unknown) {
    return request.post(`${settingPrefixURL}/send-otp`, data);
  },

  // Phone verification
  sendPhoneVerification(data: unknown) {
    return request.post(`${settingPrefixURL}/send-phone-verification`, data);
  },
  verifyPhoneVerification(data: unknown) {
    return request.post(`${settingPrefixURL}/verify-phone-verification`, data);
  }
};

const SettingAPIPaths = {
  companyProfile: `${settingPrefixURL}/company-profile`
};

export default { ...SettingAPI, ...SettingAPIPaths };
